export { default } from './EndpageImage';
export type { Props as EndpageImageProps, ShadedBackgroundColorProp } from './EndpageImage';
